// src/pages/Services.js
import React from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaCheckCircle,
  FaShieldAlt,
  FaTools,
  FaCloud,
  FaLaptopMedical,
  FaDatabase,
  FaClipboardCheck,
} from "react-icons/fa";
import "./Services.css";

const services = [
  {
    icon: <FaClipboardCheck />,
    title: "IT Health Check",
    price: "$149 fixed",
    path: "/it-health-check",
    text: "A clear snapshot of your computers, network, backups, and security so you know what needs attention first.",
  },
  {
    icon: <FaTools />,
    title: "Ongoing IT Support",
    price: "From $99/month",
    path: "/managed-it-services",
    text: "Month-to-month support for small teams that need reliable help without a corporate MSP contract.",
  },
  {
    icon: <FaLaptopMedical />,
    title: "Computer Repair",
    price: "Diagnostics + repair",
    path: "/computer-repair",
    text: "Troubleshooting, upgrades, cleanup, and practical fixes for the machines your business depends on.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Cybersecurity",
    price: "Risk-first setup",
    path: "/cybersecurity",
    text: "Security basics done right: updates, access controls, MFA, endpoint protection, and backup awareness.",
  },
  {
    icon: <FaCloud />,
    title: "Cloud Services",
    price: "Setup + cleanup",
    path: "/cloud-services",
    text: "Microsoft 365, Google Workspace, cloud storage, shared access, and backup workflows that make sense.",
  },
  {
    icon: <FaDatabase />,
    title: "Data Backup & Recovery",
    price: "Protect the essentials",
    path: "/data-backup-recovery",
    text: "Backup checks, recovery planning, and safer storage so a dead laptop or bad sync does not become a disaster.",
  },
];

function Services() {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="services-hero-card">
          <p className="services-eyebrow">Shreveport-Bossier small business IT</p>
          <h1>Practical IT help without the corporate runaround.</h1>
          <p className="services-lede">
            Start with a quick health check, choose a monthly support plan, or call in help when something is slowing the business down.
          </p>
          <div className="services-hero-actions">
            <Link to="/contact-us" className="services-primary">Talk through what you need</Link>
            <Link to="/it-health-check" className="services-secondary">Start with the $149 Health Check</Link>
          </div>
        </div>
      </section>

      <section className="services-grid-section" aria-labelledby="services-list-title">
        <div className="services-section-heading">
          <p className="services-eyebrow">Choose your path</p>
          <h2 id="services-list-title">Services that feel clear, local, and manageable.</h2>
          <p>No mystery packages. No jargon wall. Just the right next step for where your business is today.</p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <Link to={service.path} className="service-card-link" key={service.title}>
              <article className="service-card">
                <div className="service-icon">{service.icon}</div>
                <div>
                  <h3>{service.title}</h3>
                  <p className="service-price">{service.price}</p>
                  <p>{service.text}</p>
                </div>
                <span className="service-learn">Learn more <FaArrowRight /></span>
              </article>
            </Link>
          ))}
        </div>
      </section>

      <section className="services-reassurance">
        <div className="reassurance-card">
          <FaCheckCircle />
          <span>No long-term contracts</span>
        </div>
        <div className="reassurance-card">
          <FaCheckCircle />
          <span>Local to Shreveport/Bossier</span>
        </div>
        <div className="reassurance-card">
          <FaCheckCircle />
          <span>Plain-English recommendations</span>
        </div>
      </section>
    </div>
  );
}

export default Services;
